<button
    class="btn btn-sm text-xs border-0 rounded bg-transparent d-flex align-items-center  ms-3 mt-2 fw-bold"
   @click="$router.go(-1)">
    <i class="fa-solid fa-circle-arrow-left fa-lg me-2"></i>
    <slot>Back</slot>
</button>